import { appRouterPaths } from 'app-migration/constants/constants';
import { useRouter as useNextRouter } from 'next/navigation';
import { useHistory } from 'react-router-dom';

import useReactRouterPageCheck from './useReactRouterPageCheck';

const useRouter = () => {
    // React navigation
    const history = useHistory();

    // Next navigation
    const router = useNextRouter();

    const isReactRouter = useReactRouterPageCheck();

    return {
        push: (to: string) =>
            !appRouterPaths.includes(to.split('?')[0]) && !to.includes('/markets') && !!history
                ? history.push(to)
                : router.push(to),
        replace: isReactRouter ? history.replace : router.replace,
        back: isReactRouter ? history.goBack : router.back,
        forward: isReactRouter ? history.goForward : router.forward,
    };
};

export default useRouter;
